import React from 'react';
import AIEduButton from '../../components/Button/AIEduButton';
import AIEduDialog from '../../components/Dialog/AIEduDialog';
import { useIntl } from 'react-intl';

const DeleteDeviceDialog = ({
    hideDeleteDevicesDialog,
    deleteSelectedDevices,
    visible,
    deleteMessage,
    dialogTitle,
    actionLabel,
    actionClass,
}) => {
    const intl = useIntl();
    const { formatMessage: f } = intl;
    
    const deleteUserDialogFooter = (
        <div className='flex justify-content-end'>
            <AIEduButton
                label={f({ id: 'AI_EDU_CANCEL' })}
                className='btnSecondary'
                onClick={hideDeleteDevicesDialog}
            />
            <AIEduButton
                label={actionLabel}
                className={actionClass}
                onClick={deleteSelectedDevices}
            />
        </div>
    );

    const deleteDeviceTitle = () => {
        return (
            <div
                className='flex justify-content-between pb-2'
                style={{ borderBottom: '1px solid var(--primary-background)' }}
            >
                <div>{dialogTitle}</div>
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={hideDeleteDevicesDialog}
                >
                    <i className='pi pi-times' />
                </div>
            </div>
        );
    };

    return (
        <AIEduDialog
            visible={visible}
            style={{ width: '40rem', fontFamily: 'SamsungOne-600, sans-serif' }}
            title={deleteDeviceTitle}
            footer={deleteUserDialogFooter}
            onHide={hideDeleteDevicesDialog}
            content={
                <>
                    <i
                        className='pi pi-exclamation-triangle mr-3'
                        style={{ fontSize: '2rem' }}
                    />
                    <span>{deleteMessage}</span>
                </>
            }
        />
    );
};

export default DeleteDeviceDialog;
